/* eslint-disable
    import/default,
    import/namespace,
    import/no-duplicates,
    import/no-named-as-default,
    import/no-named-as-default-member,
    import/no-unresolved,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import EmbedConstants from 'constants/EmbedConstants'
import EmbedQueries from 'queries/EmbedQueries'

const EmbedStore = Marty.createStore({
  id: 'EmbedStore',

  getInitialState() {
    return {
      embedsById: {},
      lastCreatedEmbedId: undefined
    }
  },

  handlers: {
    fetchEmbedListDone: EmbedConstants.EMBED_FETCH_DONE,
    createEmbedDone: EmbedConstants.EMBED_CREATE_DONE
  },

  // Inbox List Handlers
  getOrFetchEmbedList() {
    return this.fetch({
      id: 'fetchEmbedList',
      locally() {
        if (this.hasAlreadyFetched('fetchEmbedList')) {
          return this.state.embedsById
        }
      },
      remotely() {
        return this.app.queries.EmbedQueries.fetchEmbedList()
      }
    })
  },

  getLastCreatedEmbed() {
    return this.state.embedsById[this.state.lastCreatedEmbedId]
  },

  fetchEmbedListDone(embeds) {
    const embedsById = _.keyBy(embeds, 'id')
    return this.setState({ embedsById })
  },

  createEmbedDone(inboxId, embed) {
    const embedsById = _.cloneDeep(this.state.embedsById) || {}
    embedsById[embed.id] = embed
    return this.setState({ embedsById, lastCreatedEmbedId: embed.id })
  }
})

export default EmbedStore




// WEBPACK FOOTER //
// ./src/scripts/stores/EmbedStore.js